import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface RegtankLivenessWebVerifyLinkData {
  token: string;
  documentId: number;
  redirectUrl: string;
  agreementName: string;
}

const getRegtankLivenessWebVerifyLink = async ({
  token,
  documentId,
  redirectUrl,
  agreementName,
}: RegtankLivenessWebVerifyLinkData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/regtank-liveness-webverify`,
      { documentId, redirectUrl, agreementName },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    (error as Error).message = message;
    throw error;
  }
};

export default getRegtankLivenessWebVerifyLink;
